module.exports = __webpack_public_path__ + "img/3.29d21635.gif";